<template>
  <section class="stats">
    <div class="stats__inner">
      <div class="stats__item" v-for="(item, i) in items" :key="i">
        <img :src="item.icon" alt="" class="stats__icon" />
        <div class="stats__text">
          <h5 class="stats__num" v-count>{{ item.num }}</h5>
          <p class="stats__label">{{ $t(item.labelKey) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import building01 from '@/assets/img/logos/building-01.svg'
import building02 from '@/assets/img/logos/building-02.svg'
import building03 from '@/assets/img/logos/building-03.svg'
import building04 from '@/assets/img/logos/building-04.svg'

export default {
  name: 'StatistikaPart',
  data() {
    return {
      items: [
        { icon: building01, num: '39 283', labelKey: 'home.statMaktabgacha' },
        { icon: building02, num: '11 318', labelKey: 'home.statUmumiy' },
        { icon: building03, num: '802',    labelKey: 'home.statKasbiy' },
        { icon: building04, num: '217',    labelKey: 'home.statOliy' }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/components/03prezident/statistika.scss';
</style>
